import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import { useResponsive } from '../../components/drawerNavBar/use-responsive'
import { NAV, HEADER } from "./config-layout"


const SPACING = 8;


interface MainProps {
    children?: any,
    sx?: any,
    other?:any,
}



export default function Main(props: MainProps) {

    const lgUp = useResponsive('up', 'lg')

    const { children, sx, other } = props


    return (
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                minHeight: 1,
                display: 'flex',
                flexDirection: 'column',
                py: `${HEADER.H_MOBILE + SPACING}px`,
                ...(lgUp && {
                px: 2,
                py: `${HEADER.H_DESKTOP + SPACING}px`,
                width: `calc(100% - ${NAV.WIDTH}px)`,
                }),
                ...sx,
            }}
            {...other}
        >
            {children}
        </Box>
    )

}


Main.propType = {
    children: PropTypes.node,
    sx: PropTypes.object
}